const payments = (state) => state.payments;

export default payments;
